import { micromodal } from "micromodal";

export function modal() {
  MicroModal.init();
  if (window.document.body.id === 'top') { //トップページのみの場合
    function modal(modalBtn,modalId) {
        const modalButton = document.querySelector(modalBtn);
        modalButton.addEventListener("click", () => {
            if (modalButton.classList.contains("is-open")) {
                modalButton.ariaExpanded = false;
                MicroModal.close(modalId, {
                    awaitCloseAnimation: true,
                });
                modalButton.classList.remove("is-open");
            } else {
                modalButton.ariaExpanded = true;
                MicroModal.show(modalId, {
                    disableScroll: true, // ページスクロールを無効に
                    awaitOpenAnimation: true, // 開閉時のアニメーションを可能に
                    onClose: () => {
                        modalButton.ariaExpanded = false;
                        modalButton.classList.remove("is-open");
                    }
                });
                modalButton.classList.add("is-open");
            }
        });
    }
    modal(".js-modalButton1","modal-1");
    modal(".js-modalButton2","modal-2");
  } //トップページのみの場合
}
